const config = require("../config.js");
const UTILS = require("../libs/utils.js");
module.exports = function () {
  var vO225 = {
    _html: {
      settings: {
        input: {
          generic: function (p9981) {
            return "<input type='" + p9981.type + "' name='" + p9981.type + "' id='slid_" + p9981.key + "' class='inputGrey2' placeholder='" + p9981.placeholder + "'\n\t\t\t\t\t\t\tvalue='" + p9981.val + "' oninput='setSetting(\"" + p9981.key + "\", this.value)'/>";
          },
          color: function (p9982) {
            return "<input type='color' name='color' id='slid_" + p9982.key + "' style='float:right' value='" + p9982.val + "'\n\t\t\t\t\t\t\toninput='setSetting(\"" + p9982.key + "\", this.value)'/>";
          },
          switch: function (p9983) {
            return "<label class='switch' style='margin-left:10px'><input type='checkbox' onclick='setSetting(\"" + p9983.key + "\", this.checked)'\n\t\t\t\t\t\t\t" + (p9983.val ? "checked" : "") + "><span class='slider'></span></label>";
          },
          slider: function (p9984) {
            return "<input type='number' class='sliderVal' id='slid_input_" + p9984.key + "' min='" + p9984.min + "' max='" + p9984.max + "'\n\t\t\t\t\t\t\tvalue='" + p9984.val + "' onkeypress='return delayExecute(\"" + p9984.key + "\", this, " + p9984.delay + ")' style='margin-right:0px;border-width:0px'/>\n\t\t\t\t\t\t\t<div class='slidecontainer' style='margin-top: -8px;" + (p9984.style || "") + "'><input type='range' id='slid_" + p9984.key + "' min='" + p9984.min + "' max='" + p9984.max + "' step='" + p9984.step + "'\n\t\t\t\t\t\t\tvalue='" + p9984.val + "' class='sliderM' oninput='setSetting(\"" + p9984.key + "\", this.value)'></div>";
          },
          select: function (p9985, p9986) {
            p9986 = p9985.options || p9986;
            return "<select onchange='setSetting(\"" + p9985.key + "\", this.value)' class='inputGrey2'>\n\t\t\t\t\t\t\t" + Object.keys(p9986).map(p9987 => "<option value='" + p9987 + "' " + (p9987 == p9985.val ? "selected" : "") + ">" + p9986[p9987] + "</option>") + "</select>";
          }
        }
      }
    },
    action: function (p9988) {
      let vVO225 = vO225;
      p9988.forEach(p9989 => vVO225 = vVO225[p9989]);
      switch (vVO225.type) {
        case "button":
          if (vVO225.onclick) {
            vVO225.onclick();
          }
      }
    },
    _build: function (p9990) {
      let vVO2252 = vO225;
      p9990.forEach(p9991 => vVO2252 = vVO2252[p9991]);
      return Object.keys(vVO2252).map(p9992 => {
        let v8012 = vVO2252[p9992];
        let v8013 = "GUI.action(" + JSON.stringify([...p9990, p9992]).replace(/\"/g, "'") + ", this)";
        switch (v8012.type) {
          case "button":
            return "<div id=\"" + (v8012.id || "") + "\" style=\"" + (v8012.style || "") + "\" onclick=\"" + v8013 + "\">" + (v8012.html || "") + "</div>";
          default:
            return "";
        }
      }).join("\n");
    }
  };
  window.GUI = UTILS.removePrivateKeys(vO225);
  return vO225;
};